import { Vector3 } from 'three'

export function calculateRelativePositionNext(
  absoluteX: number,
  absoluteY: number,
  absoluteZ: number,
  resultPoint: Vector3,
  rotation: number,
): [number, number, number] {
  if (!absoluteX && !absoluteY && !absoluteZ) return [0, 1, 10]
  const signC = Math.sign(Math.cos(rotation))
  const signS = Math.sign(Math.sin(rotation))

  if (signC < 0 && signS < 0) {
    let relativeX = resultPoint?.x - absoluteX
    let relativeZ = resultPoint?.z - absoluteZ
    const rotatedX = relativeX * Math.cos(rotation) + relativeZ * Math.sin(rotation)
    const rotatedZ = -relativeX * Math.sin(rotation) - -relativeZ * Math.cos(rotation)
    relativeX = rotatedX
    relativeZ = rotatedZ

    return [relativeX, 1, relativeZ]
  }

  let relativeX = resultPoint?.x - absoluteX
  let relativeZ = resultPoint?.z - absoluteZ
  const rotatedX = relativeX * Math.cos(rotation) + relativeZ * Math.sin(rotation)
  const rotatedZ = -relativeX * Math.sin(rotation) + relativeZ * Math.cos(rotation)
  relativeX = rotatedX
  relativeZ = rotatedZ
  return [relativeX, 1, relativeZ]
}
export function calculateRelativePositionPrev(
  absoluteX: number,
  absoluteY: number,
  absoluteZ: number,
  resultPoint: Vector3,
  rotation: number,
  is3D?: boolean,
): [number, number, number] {
  if (!absoluteX && !absoluteY && !absoluteZ) return [0, 1, 10]
  let relativeX = -resultPoint?.x + absoluteX
  let relativeZ = -resultPoint?.z + absoluteZ

  const signC = Math.sign(Math.cos(rotation))

  const rotatedX = -relativeX * Math.cos(rotation) + relativeZ * Math.sin(-rotation)
  const rotatedZ = relativeX * Math.sin(rotation) - relativeZ * Math.cos(rotation)
  if (signC < 0 && signC < 0) {
    const rotatedX = relativeX * Math.cos(rotation) + relativeZ * Math.sin(rotation)
    const rotatedZ = -relativeX * Math.sin(rotation) + relativeZ * Math.cos(rotation)
    relativeX = -rotatedX
    relativeZ = -rotatedZ
    return [relativeX, is3D ? 0 : 1, relativeZ]
  }
  if (signC > 0) {
    relativeX = rotatedX
    relativeZ = rotatedZ
    return [relativeX, is3D ? 0 : 1, relativeZ]
  }
  relativeX = -rotatedX
  relativeZ = -rotatedZ
  return [relativeX, is3D ? 0 : 1, relativeZ]
}
